import { string } from "prop-types";
import React from "react";

class Adsense extends React.Component {
  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    const { adSlotId, width, height } = this.props;
    return (
      <ins
        className="adsbygoogle"
        style={{ display: `inline-block`, width: `${width}` + "px", height: `${height}` + "px" }}
        data-ad-client="ca-pub-9082438933551282"
        data-ad-slot={adSlotId}
      />
    );
  }
}

Adsense.propTypes = {
  adSlotId: string,
  width: string,
  height: string
};
export default Adsense;

class ResponsiveAdsense extends React.Component {
  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    const { adSlotId, styles } = this.props;

    return (
      <ins className="adsbygoogle" style={styles} data-ad-client="ca-pub-9082438933551282" data-ad-slot={adSlotId} />
    );
  }
}
ResponsiveAdsense.propTypes = {
  adSlotId: string,
  styles: Object
};

class AdsenseSideBar extends React.Component {
  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
  render() {
    const { adSlotId, width, height } = this.props;
    return (
      <ins
        className="adsbygoogle"
        style={{ display: `inline-block`, width: `${width}` + "px", height: `${height}` + "px" }}
        data-ad-client="ca-pub-7002491002409919"
        data-ad-slot={adSlotId}
        data-full-width-responsive="true"
      />
    );
  }
}

AdsenseSideBar.propTypes = {
  adSlotId: string,
  width: string,
  height: string
};

export { ResponsiveAdsense };
export { AdsenseSideBar };
